// extracted by mini-css-extract-plugin
export default {"jackpot":"Jackpot__jackpot--29w","title":"Jackpot__title--Pom","infoIcon":"Jackpot__infoIcon--Pbr","shine":"Jackpot__shine--psI","sparkle":"Jackpot__sparkle--btT"};